import moment from "moment"
import React, { useEffect, useState } from "react"
import { Dimensions, StyleSheet, TouchableOpacity, View } from "react-native"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { Spacer } from "@Components/Space"

moment.locale("fr")

const { width } = Dimensions.get("screen")

export const DaySelector = () => {
    const today = new Date()
    const week = ["L", "Mar", "Mer", "J", "V", "S", "D"]
    useEffect(() => {}, [])
    const [selectedDay, setSelectedDay] = useState("L")

    const DayComponent = ({ date, hidden }) => {
        const selected = hidden ? false : selectedDay == date
        const selectedColor = selected ? baseColors.green.primary : hidden ? baseColors.white : baseColors.green.light
        const color = selected ? baseColors.white : hidden ? baseColors.white : baseColors.green.primary

        return (
            <TouchableOpacity
                style={{
                    ...styles.container,
                    backgroundColor: selectedColor
                }}
                onPress={() => {
                    !hidden && setSelectedDay(date)
                }}
            >
                <View>
                    <OpenSansText textAlign={"center"} fontSize={16} color={color}>
                        {!hidden && date.substr(0, 1)}
                    </OpenSansText>
                </View>
            </TouchableOpacity>
        )
    }

    return (
        <View style={{ width: width - 40 }}>
            <View style={styles.col}>
                {week.slice(0, 5).map((day, i) => (
                    <DayComponent date={day} key={i} />
                ))}
            </View>
            <Spacer height={20} />

            <View style={styles.DayComponentContainer}>
                {[...week.slice(0, 3).reverse(), ...week.slice(5, 7).reverse()].map((day, i) => (
                    <DayComponent hidden={day == "S" || day == "D" ? false : true} key={i} date={day} />
                ))}
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "column",
        padding: 10,
        alignContent: "center",
        alignItems: "center",
        width: 47,
        height: 47,
        borderRadius: 10,
        justifyContent: "center",
        alignItems: "center",
        alignContent: "center"
    },
    col: { flexDirection: "row", justifyContent: "space-between" },
    DayComponentContainer: {
        flexDirection: "row-reverse",
        flex: 2,
        flexGrow: 2,
        justifyContent: "space-between"
    }
})
